import {State} from "../store/rootReducers";

export function selectLogin(state: State) {
    return state.auth.login;
}

export function selectBalance(state: State) {
    return state.auth.balance;
}
